import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-1ed461aa.js';
import { m as marginPropTypes } from './spacing-0f39ba4a.js';
import { S as SvgIcon } from './SvgIcon-11e6ad98.js';

function IconFeather(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.968 2.773A6.405 6.405 0 0 1 20.9 7.3a6.4 6.4 0 0 1-1.875 4.526l-2.384 2.39a1.01 1.01 0 0 1-.174.174l-3.508 3.517a1 1 0 0 1-.708.294H5.014l-2.408 2.406a1 1 0 1 1-1.414-1.415L3.6 16.786V9.553a1 1 0 0 1 .293-.707l6.075-6.073Zm5.458 9.829 2.184-2.19a4.4 4.4 0 0 0-3.114-7.513 4.405 4.405 0 0 0-3.114 1.289L5.6 9.968v4.82L7.487 12.9a.87.87 0 0 1 .012-.012l6.295-6.292a1 1 0 0 1 1.414 1.415l-4.593 4.59h4.81Zm-6.812 2h4.816l-1.594 1.599H7.015l1.6-1.599Z"
  }));
}
IconFeather.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconFeather.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconFeather as default };
